import * as FinishSelector from "../modules/finishSelector";
import * as ProductMedia from "../modules/productMedia";

// @ts-ignore
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
import {delineate} from "../../lib/delineate";
import { FeaturedProductSlider } from "../modules/featuredProductSlider";

namespace NHW.controllers.productDetail {
	function setupEvents() {
		$('.js-more-packaging-options').on('click', (e) => {
			let $parentEl = $(e.target).parent();
			let $popup = $parentEl.find('.product-buy-options__options');

			if(!$popup.hasClass('state-visible')) {
				$popup.addClass('state-visible');
			} else {
				$popup.removeClass('state-visible');
			}

			e.preventDefault();
		});

		$(document).on('mouseup touchend', function(e)
		{
			let elem:any = $(".product-buy-options__options");
			let link:any = $('.js-more-packaging-options');
			if ((!elem.is(e.target) && !link.is(e.target)) && (elem.has(e.target).length === 0 && link.has(e.target).length === 0))
			{
				elem.removeClass('state-visible');
			}
		});
	}

	function pushTrackingEvents(){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'Page Load',
			'product_name': $('.js-product-display-name').data('product-display-name')
		});
	}

	function setupSwiper() {
		const breakpoint = window.matchMedia( '(min-width:768px)' );
		let mySwiper;
		let $swiperContainer = $('.js-product-swiper-container');
		let $swiperWrapper = $('.js-product-swiper-wrapper');
		let $swiperSlide = $('.js-product-swiper-slide');

		const breakpointChecker = function() {
			if ( breakpoint.matches === true ) {
				if ( mySwiper !== undefined ) {
					$swiperContainer.removeClass('swiper-container');
					$swiperWrapper.removeClass('swiper-wrapper');
					$swiperSlide.removeClass('swiper-slide');
					mySwiper.destroy( true, true );
				}
				return;
			} else if ( breakpoint.matches === false ) {
				return enableSwiper();
			}
		};

		const enableSwiper = function() {
			$swiperContainer.addClass('swiper-container');
			$swiperWrapper.addClass('swiper-wrapper');
			$swiperSlide.addClass('swiper-slide');

			$('.js-product-swiper-container').each(function(index) {
				let $this = $(this);
				let parentWrapper = $this.closest('.js-product-media');
				parentWrapper.find('.product-buy-options__swiper-navigation').addClass('product-buy-options__swiper-navigation-' + index);
				parentWrapper.find('.product-buy-options__counter').addClass('product-buy-options__counter-' + index);
				$this.addClass('product-carousel-' + index);


				let carouselList = [];
				let $counterContainer = $(`.product-buy-options__counter-${index}`);

				mySwiper = new Swiper ('.product-carousel-' + index, {
					loop: false,
					slidesPerView: '1',
					centeredSlides: true,
					keyboardControl: true,
					grabCursor: true,
					navigation: {
						nextEl: `.product-buy-options__swiper-navigation-${index} .swiper-button-next`,
						prevEl: `.product-buy-options__swiper-navigation-${index} .swiper-button-prev`,
					},
					on: {
						init: function (swiper:any) {
							let $slideLength = $(`.js-product-swiper-container .swiper-slide:not(.swiper-slide-duplicate)`).length;
							$counterContainer.text(`${swiper.realIndex + 1}/${$slideLength}`);
						},
						slideChange: function (swiper:any) {
							let $slideLength = $(`.js-product-swiper-container .swiper-slide:not(.swiper-slide-duplicate)`).length;
							$counterContainer.text(`${swiper.realIndex + 1}/${$slideLength}`);
						}
					}
				});

				carouselList.push(mySwiper);
				mySwiper.init();
			});
		};

		breakpoint.addListener(breakpointChecker);
		breakpointChecker();
	}

	function selectSize() {
		$('.js-select-size').on('change', (e) => {
			let url = $(e.target).val();

			if (url) {
				(<any>window.location) = url; // redirect
			}
			return false;
		});
	}

	function gtmEvents() {
		let activeFinish = $(".js-select-finish option:selected").text();
		let activePackaging = $(".product-buy-options__info").data("packaging");
		let optionText = $('.js-select-size option:selected').text();
		let dataLayer = window.dataLayer || [];
		dataLayer.push({
			'finish' : activeFinish ? activeFinish : "Unavailable", // values should be what ever the user selects from the list
			'size' : optionText ? optionText : "Unavailable", // values should be what ever the user selects from the list
			'packaging' : activePackaging ? activePackaging : "Unavailable", // values should be what ever the user selects from the list
			'event' : 'PDP_dropdown_selections' // fire on any clicks on the dropdown selections on PDPs
		});
	}

	function askQuestion() {
		function eventFire(el, etype){
			if (el.fireEvent) {
				el.fireEvent('on' + etype);
			} else {
				var evObj = document.createEvent('Events');
				evObj.initEvent(etype, true, false);
				el.dispatchEvent(evObj);
			}
		}

		$('body').on('click', '.bv_war_button', function (event) {
        event.preventDefault();       
        eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#reviews"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
			});
		});

		$('body').on('click', '.bv_aaq_button', function (event) {
			event.preventDefault();       
			eventFire(document.querySelector('.js-tab[data-target="#qas"]'), 'click');
			let topPosition = document.querySelector('.js-tab[data-target="#qas"]').getBoundingClientRect().top + document.documentElement.scrollTop;
			window.scrollTo({
				top: topPosition,
				behavior: 'smooth',
			});
		});
		$('body').on('click', '.bv_ratings_summary', function (event) {
			event.preventDefault();      
			eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
			let topPosition = document.querySelector('.js-tab[data-target="#reviews"]').getBoundingClientRect().top + document.documentElement.scrollTop;
			window.scrollTo({
				top: topPosition,
				behavior: 'smooth',
			});
		});
		
		$('body').on('mousedown', '.bv-write-review-label, .bv-content-product-stats-item-reviews', function(event){
			event.preventDefault();
			eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
		});
		$('body').on('mousedown', '.bv-qa-stats-questions, .bv-qa-stats-answers, .bv-content-product-stats-item-answers, .bv-content-product-stats-item-questions', function(event){
			event.preventDefault();
			eventFire(document.querySelector('.js-tab[data-target="#qas"]'), 'click');
		});


	}

	function delineateReviewLinks() {
		new delineate('.js-review-list');
	}

	export function init() {
		setupEvents();
		setupSwiper();
		selectSize();
		pushTrackingEvents();
		FinishSelector.init();
		delineateReviewLinks();
		ProductMedia.init();
		askQuestion();
		FeaturedProductSlider.init();
		gtmEvents();
	}
}

NHW.controllers.productDetail.init();
